// extracted by mini-css-extract-plugin
export default {"modalFormLabel":"styles_modalFormLabel__c15Of"};